import Vue from "vue";
import App from "./App.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import router from "./router";
import store from "./store";
import { logEvent } from "./services/analytics";

var VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo);

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.component("FontAwesomeIcon", FontAwesomeIcon);
Vue.config.productionTip = false;

logEvent(process.env.VUE_APP_ANALYTICS_EVENT_BASE + "AppOpen");
Vue.prototype.$logEvent = logEvent;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
